<div [formGroup]="form" class="members-form-root">

  <div class="member-table-card">
    <table class="project-members-table">
      <thead>
          <tr>
              <th *ngIf="userCanManageMembers()" class="col-del">Del</th>
              <th>Name</th>
              <th>EPPN</th>
              <th class="col-role">Role</th>
          </tr>
      </thead>
      <tbody formArrayName="members">
          <tr *ngIf="members.controls.length == 0">
              <td [attr.colspan]="userCanManageMembers() ? 4 : 3" class="empty-row">No members found.</td>
          </tr>
          <tr *ngFor="let member of members.controls; let i = index" [formGroupName]="i">
              <td *ngIf="userCanManageMembers()" class="col-del">
                  <i class="fa fa-minus-circle remove-member-btn" (click)="removeMember(member)" aria-hidden="true"></i>
              </td>
              <td>
                  {{ member.get('fullName').value }}
              </td>
              <td>
                  {{ member.get('eppn').value }}
              </td>
              <td>
                  <select *ngIf="userCanManageMembers()" class="member-role-select" formControlName="role" (change)="onMemberRoleChanged(member)">
                      <option *ngFor="let role of projectRoles" [value]="role.name">{{ role.label }}</option>
                  </select>
                  <span *ngIf="!userCanManageMembers()" class="role-pill">{{ roleLabel(member.get('role').value) }}</span>
              </td>
          </tr>
      </tbody>
    </table>
  </div>

  <!--
  <br />
  <button id="member-form-save-button" [ngClass]="{'disabled': !submitBtnEnabled}" [disabled]="!submitBtnEnabled" (click)="saveForm()">
      <img *ngIf="showLoadingIndicator" src="../../../../assets/loading-indicator-4-light.svg">
      <i *ngIf="!showLoadingIndicator" class="fa fa-save" aria-hidden="true"></i>
      &nbsp;
      {{ submitBtnLabel }}
  </button>
  -->
</div>
